import React, { useEffect, useState } from "react";
import api from "../../../common/lib/api";
import moment from "moment";
import * as XLSX from "xlsx";
import Managed, { useManaged } from "../../../common/components/Managed";
import { shortenAtlasId } from "../../shortenAtlasId";
import CompanyData, { createDownloadUrl } from "./CompanyData";
import { Button } from "@blueprintjs/core";
import AsyncButton from "../../../common/components/AsyncButton";

const DEFAULT_STATE = [];

export default function Page({ system, period }) {
  const [state, setState, setError] = useManaged(DEFAULT_STATE);
  const [selected, setSelected] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const data = await api
          .get(
            "/bill-data-report/" + system + "/times/" + period + "/companies"
          )
          .then((res) => res.data.data);
        setState(data);
        setSelected(data[0].companyId);
      } catch (e) {
        setError(e);
      }
    })();
  }, [period, setError, setState, system]);

  return (
    <Managed state={state}>
      {selected !== "all" && (
        <>
          <div>
            <strong>Company: </strong>
            <p className="bp3-select">
              <select
                value={selected}
                onChange={(e) => {
                  setSelected(e.target.value);
                }}
              >
                {state.data.map((company) => (
                  <option value={company.companyId} key={company.companyId}>
                    {company.name || "[Deleted]"} (
                    {shortenAtlasId(company.companyId, true)}, {company.count}{" "}
                    items)
                  </option>
                ))}
              </select>
            </p>
          </div>
          <Button
            onClick={(e) => {
              if (
                // eslint-disable-next-line no-restricted-globals
                confirm(
                  "This will show all companies billing data for selected period. It will take a long time. Do you want to continue?"
                )
              ) {
                setSelected("all");
              }
            }}
          >
            Show All Companies
          </Button>
        </>
      )}
      {selected === "all" ? (
        state.data.map((company) => (
          <>
            <h2>
              {company.name || "[Deleted]"}
              <small>({shortenAtlasId(company.companyId)})</small>
            </h2>
            <CompanyData
              system={system}
              period={period}
              companyId={company.companyId}
            />
          </>
        ))
      ) : (
        <CompanyData system={system} period={period} companyId={selected} />
      )}
      <br />
      <AsyncButton
        onClick={async () => {
          if (
            !window.confirm(
              "This my take a long time. Would you like to continue?"
            )
          ) {
            return;
          }

          const all = [];

          for (const company of state.data) {
            const {
              data: { data },
            } = await api.get(
              `/bill-data-report/${system}/times/${period}/companies/${company.companyId}/export-data`
            );

            all.push(...data);
          }

          const wb = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(
            wb,
            XLSX.utils.json_to_sheet(all),
            `Billing Data Export for ${period}`
          );

          const binaryData = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
          });

          const a = document.createElement("a");
          a.href = createDownloadUrl(binaryData);
          a.download = `${period}_Billing_Export_${moment().format(
            "YYYYMMDD_HHmmss"
          )}.xlsx`;
          a.click();
        }}
      >
        Download All Data
      </AsyncButton>
    </Managed>
  );
}
